export const enTexts = {
  // Titles
  encyclopediaTitle: "Ghalichin Encyclopedia",
  insuranceAndServicesTitle: "Ghalichin insurance And Services",
  generatorTitle: "Ghalichin Generator",

  home: "home",
  menu: "Menu",
  contactUs: "contact Us",
  loginRegister: "login/ Register",
  encyclopedia: "Encyclopedia",
  vr: "virtual reality",
  buy: "buy",
  loading: "loading",
  rugGenerate: "carpet layout",
  insuranceAndServices: "insurance And Services",
  insurance: "insurance",
  brand: "brand",
  shaneh: "Reeds",
  density: "density",
  yarn: "yarn",
  rug_size_6: "rug_size_6",
  rug_size_9: "rug_size_9",
  rug_size_12: "rug_size_12",
  decoration: "decoration",
  room_services: "services:",
  floor_covering: "floor",
  wall: "wall",
  roof: "roof",
  selectImage: "select Image",
  wishListText:
    "You can add the created carpets to the favorites list to see a preview of them later.",
  services: "services",
  specialPosts: "special Posts",
  preview: "preview",
  lachakToranj: "lachak Toranj",
  modern: "modern",
  afshan: "afshan",
  kheshti: "kheshti",
  your_picture: "Your Picture",
  border: "border",
  corner: "corner",
  background: "background",
  toranj: "toranj",
  tile: "tile",
  pattern: "pattern",
  rugSettings: "tile",
  wishList: "wishList",
  addToWishList: "add To Wish List",
  listIsEmpty: "listIsEmpty",
  rotate: "rotate",
  clear: "clear",
  latest: "latest",
  oldest: "oldest",
  onSale: "onSale",
  searchingForSellers: "searching For Sellers",
  storesForThisRug: "stores For This Rug",
  noStoreForSelectedRug: "no Store For Selected Rug",
  selectOneSimilarRug: "select One Similar Rug",
  selectedRugs: "selected Rugs",
  rugSimilarityPercentage: "rug Similarity Percentage",
  similarRugs: "similar Rugs",
  availableRugSizes: "available Rug Sizes",
  phoneNumber: "phone Number",
  address: "address",
  filters: "Filters",
  filter: "Filter",
  previewEmptyHelpText: "You must add at least one rug to the list",
  camera: "Camera",
  upload: "Upload",
  selectSizeYourPic: "اندازه فرش",
  // Texts

  landingText: `Creating added value for the buying process is one of the major concerns of any business. This added value can be examined and acted upon in three ways. From the point of view of the consumer, the seller and ultimately the producer.Ghalichin goal is to create this added value in a digital and secure platform. Our approach is to offer the sale and purchase of"carpet goods" in a new and reliable environment`,
  wikipediaBoldText: `What is the difference between machine-made and Hand-knotted carpets? What should I pay attention to when choosing a quality carpet? How do I choose the size of the carpet? What is the right carpet color for my decor? What does comb and density in a car carpet mean? What does Raj mean in Hand-knotted?`,
  wikipediaLightText: `Sufficient information before purchasing is one of the requirements for purchasing any product. Ghalichin in the encyclopedia section seeks to answer your questions and provide the most accurate information about the material, design, elegance, fibers, color, dimensions and design of the carpet and rug`,
  layOutBoldText: `What was my neighbor's carpet like? Do you agree that the background of their carpet was very similar to our home decor?
I wish I could see the details of the carpets carefully without going around the market from home and not bother the sellers`,

  layOutLightText: `carpet layout is our special and exclusive service for those who are interested in playing with the details of their carpet and finding the closest carpet to their choice and preparing it from the nearest carpet to solve their residence`,
  VRBoldText: `Ich wünschte, wir würden sagen, bringen Sie alle vier Teppiche nach Hause und wir werden einen auswählen. Passt ein moderner Teppich mehr zu unserem Dekor oder zu einem traditionellen? Wird der Teppich auf dem Parkett gut sein?`,

  VRLightText: `It may have happened to you that when you buy carpets, you like some of the designs, but it is not possible for you to spread all these carpets in your house and see their appearance with your home decoration and choose the best option.Ghalichin has many ideas for this need of yours. Simulating your home is the beginning of this path and will continue`,
  shoppingBoldText: `Do you know from whom you are buying? Can it be trusted, is it not a scam? Do they send the carpet? Isn't it better to buy in person?`,
  shoppingLightText: `Creating a secure platform for trade has always been a concern for consumers and sellers. Trust in the online sales environment is far more complex, and this is one of the obstacles to the expansion of this market, especially for valuable products. Galichin has tried to provide a safe and reliable sales platform for buying carpets for consumers and selling carpets for suppliers by creating appropriate mechanisms`,
  insuranceBoldText: `I wish the seller would do the carpet washing periodically? Where can I wash the carpet so that it does not spoil? I wish they would take our old carpet and replace it with a new one for a certain amount!Is there a place where I can rent a carpet? Do they rent new carpets?`,

  insuranceLightText: `After-sales service and warranty of valuable goods such as carpets will make shopping more enjoyable and safer for each customer. According to the needs of customers, while providing various after-sales services, Ghalichin offers other valuable services. Services such as free washing! Replace your old carpet with a new one! And carpet rental service for your short-term use of carpets !!! `,

  insuranceText: `We are all interested in buying from a place that offers us the best options both at the time of purchase and after-sales service. Ghalichin also offer a variety of services in this regard. For example, the consumer. A person who has bought the carpet from Ghalichin with insurance can benefit from the first free washing of his carpet or after a while he will receive a new carpet by paying a part of the cost. Carpet rental service is another service that will be launched soon`,

  servicesText: `We are all interested in buying from a place that offers us the best options both at the time of purchase and after-sales service. Ghalichin also offer a variety of services in this regard. For example, the consumer. A person who has bought the carpet from Ghalichin with insurance can benefit from the first free washing of his carpet or after a while he will receive a new carpet by paying a part of the cost. Carpet rental service is another service that will be launched soon`,
  Custom_Your_Carpet: "Custom Your Carpet",
  image_registration: "Image Registration",
  zoom: "Zoom",
  confirmation_and_approval: "Confirmation and Approval",
  name_and_lastname: "First Name and Last Name",
  Phone_call: "Phone Call",
  Address: "Address",
  send: "Send",
  ordering: "Ordering",
  carpet_show: "Carpet Display",
  back_market: "Back to Market",
  next: "Next",
  previous: "Previous",
  carpet_link: "Your Desired Carpet Link",
  national_Code: "National Code",
  upload_photo_and_video: "Upload Photo and Video of Your Carpet",
  photo_or_video_link: "Photo or Video Link",
  coming_back: "Return",
  the_link_of_the_carpet_you_want: "Link of the Carpet You Want",
  landing_tab: "For a full introduction of each section from the top menu and quicker access, use the bottom menu.",
  carpet_replacement: "Carpet Replacement",
  submit: "Submit",
  receiving_information: "Receiving Information",
  // login form
  login_register_tab_login: "Login",
  login_register_tab_register: "Register",
  login_register_input_email: "Email",
  login_register_input_password: "Password",
  login_register_input_repassword: "Re Password",
  login_register_btn_close: "Close",
  login_register_btn_submit_login: "Login",
  login_register_btn_submit_register: "Register",
  login_register_btn_exit: "Logout",
  order_input_command: "Comment",
  order_btn_submit: "Submit",
  preview_btn_open_file_dialog: "Upload Background Image",
  preview_btn_show_3d: "3D",
  preview_btn_totate: "Horizontal",
  preview_slider_prespective: "Perspective",
  preview_slider_size: "Size",
  preview_slider_angle_up_down: "Up and down angle",
  preview_slider_angle_left_right: "Left and right angle",
  preview_slider_rotate: "Rotation",
  profile_btn: "Profile",
  profile_txt_first_name: "First Name",
  profile_txt_last_name: "Last Name",
  profile_txt_phone_number: "Phone Number",
};
